require 'angular'

app = angular.module('workflow.app')

require('./KrakenSnapshot')

app.controller('AdverseTermsPopupController', require './AdverseTermsPopupController')
app.controller('SearchController', require('./SearchController'))
app.controller('FacetsController', require('./FacetsController'))
app.service('SubdivisionAggregator', require('./SubdivisionAggregator'))

require './Worker'
require './Sidebar'
require './ManualChecks'
